import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios'

require('vue-video-player/src/custom-theme.css')  
require('video.js/dist/video-js.css')  
import VideoPlayer from 'vue-video-player' 
//引入 hls,视频直播(m3u8)必须引入的
import 'videojs-contrib-hls'
//播放rtmp视频
import 'videojs-flash' 
const hls = require("videojs-contrib-hls")  
Vue.use(hls)  
Vue.use(VideoPlayer)

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

// NodePlayer.load(()=>{
//   new Vue({
//     render: h => h(App),
//   }).$mount('#app')
// });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");